import React from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";
import { useSelector } from "react-redux";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown";
import Select from "react-select";

const AddUpdateUI = ({
  formik,
  selectedRelationData,
  setSelectedRelationData,
  parentData,
}) => {
  const { values, errors, handleChange, handleBlur, setFieldValue } = formik;
  const { data: venue } = useSelector((state) => state.venue);
  const { data: initiatives } = useSelector((state) => state.initiative);
  const { data: performanceVenues } = useSelector(
    (state) => state.performanceVenue
  );

  return (
    <>
      <div className="row">
        <CustomTextbox
          fieldName="showName"
          value={values.showName}
          error={errors.showName}
          label={"Name Of the Show"}
          classes={"col-md-12"}
          handleBlur={handleBlur}
          inputType={"text"}
          disabled={true}
          handleChange={handleChange}
        />
        <CustomDropdown
          fieldName="initiative"
          values={selectedRelationData?.initiative}
          error={errors.initiative}
          label={"Assign the Initiative"}
          classes={"col-md-12"}
          setFieldValue={setFieldValue}
          handleChange={(value) =>
            setSelectedRelationData({
              ...selectedRelationData,
              initiative: value,
            })
          }
          options={
            initiatives
              ? initiatives?.map((data) => {
                return { label: data.title, value: data._id };
              })
              : []
          }
        />
        <CustomDropdown
          fieldName="venue"
          values={selectedRelationData?.venue}
          error={errors.venue}
          label={"Assign the Venue"}
          classes={"col-md-12"}
          setFieldValue={setFieldValue}
          handleChange={(value) => {
            setSelectedRelationData({ ...selectedRelationData, venue: value, performanceVenue: {} });
            setFieldValue("performanceVenue", "");
          }}
          options={
            venue
              ? venue?.map((data) => {
                return { label: data.title, value: data._id };
              })
              : []
          }
        />

        <CustomDropdown
          fieldName="performanceVenue"
          values={selectedRelationData?.performanceVenue}
          error={errors.performanceVenue}
          label={"Assign the Stage"}
          classes={"col-md-12"}
          setFieldValue={setFieldValue}
          handleChange={(value) =>
            setSelectedRelationData({
              ...selectedRelationData,
              performanceVenue: value,
            })
          }
          options={
            performanceVenues
              ? performanceVenues?.map((data) => {
                return { label: `${data.title} (Capacity: ${data.capacity || 0})`, value: data._id };
              })
              : []
          }
        />

        <div
          className={`form-group col-md-6 mb-3 ${errors ? "is-invalid" : "is-valid"
            }`}
        >
          <label className="text-label d-block">Date</label>
          <div className="d-block">
            <input
              type="date"
              onChange={handleChange}
              onBlur={handleBlur}
              value={
                values.date
                  ? new Date(values.date).toISOString().slice(0, 10)
                  : ""
              }
              className="input form-control"
              name="date"
            />
          </div>

          {errors && errors.date ? (
            <div
              id={`val-date-error`}
              class="invalid-feedback animated fadeInUp"
              style={{ display: "block" }}
            >
              {errors.date}
            </div>
          ) : null}
        </div>
        <div
          className={`form-group col-md-6 mb-3 ${errors ? "is-invalid" : "is-valid"
            }`}
        >
          <label className="text-label d-block">Time</label>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-center gap-2">
              <div className="flex-grow-1" style={{ flexBasis: 0, minWidth: 0 }}>
                <input
                  type="time"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.start_time}
                  className="input form-control w-100 p-2"
                  name="start_time"
                  placeholder="Start"
                />
              </div>
              <span className="text-muted flex-shrink-0 user-select-none">-</span>
              <div className="flex-grow-1" style={{ flexBasis: 0, minWidth: 0 }}>
                <input
                  type="time"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.end_time}
                  className="input form-control w-100 p-2"
                  name="end_time"
                  placeholder="End"
                />
              </div>
            </div>
            <div className="d-flex align-items-start gap-2">
              <div className="flex-grow-1" style={{ flexBasis: 0, minWidth: 0 }}>
                {errors && errors.start_time ? (
                  <div
                    id="val-start-time-error"
                    className="invalid-feedback animated fadeInUp d-block"
                  >
                    {errors.start_time}
                  </div>
                ) : null}
              </div>
              <span
                className="flex-shrink-0 user-select-none px-1"
                style={{ visibility: "hidden" }}
                aria-hidden
              >
                -
              </span>
              <div className="flex-grow-1" style={{ flexBasis: 0, minWidth: 0 }}>
                {errors && errors.end_time ? (
                  <div
                    id="val-end-time-error"
                    className="invalid-feedback animated fadeInUp d-block"
                  >
                    {errors.end_time}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="custom-checkbox mb-3 col-md-6">
          <label className="text-label d-block">Pre Booking</label>
          <div className="form-control d-flex align-items-center justify-content-between gap-2 cursor-pointer" onClick={() => setFieldValue('pre_booking', !values.pre_booking)}>
            <label
              className="form-check-label text-label fs-21 m-0"
              htmlFor="pre_booking"
            >
              Allow Pre Booking
            </label>
            <input
              type="checkbox"
              className="custom-checkbox-input"
              onChange={handleChange}
              onBlur={handleBlur}
              checked={values.pre_booking}
              value={values.pre_booking}
              name="pre_booking"
              id="pre_booking"
            />
          </div>
        </div>
        {values.pre_booking ? (
          <>
            <div className="custom-checkbox mb-3 col-md-6">
              <label className="text-label d-block">% Seats Allowed for Pre-Booking</label>
              <div
                className={`form-group mb-3 ${errors && errors.pre_booking_percentage ? "is-invalid" : "is-valid"
                  }`}
              >
                <Select
                  value={{
                    label: `${values.pre_booking_percentage}%`,
                    value: values.pre_booking_percentage,
                  }}
                  onChange={(e) => {
                    handleChange({ target: { name: 'pre_booking_percentage', value: e.value } })
                  }}
                  onBlur={() => setFieldValue(`touched.pre_booking_percentage`, true)}
                  options={[{ label: '10%', value: 10 }, { label: '20%', value: 20 }, { label: '30%', value: 30 }, { label: '40%', value: 40 }, { label: '50%', value: 50 }, { label: '60%', value: 60 }, { label: '70%', value: 70 }, { label: '80%', value: 80 }]}
                  name={`pre_booking_percentage`}
                  style={{
                    color: "#7e7e7e",
                    paddingLeft: " 15px",
                  }}
                  classNames={{
                    control: (state) => "form-control p-0 select-custom-css",
                  }}
                />

                {errors.pre_booking_percentage && (
                  <div
                    id={`val-pre_booking_percentage-error`}
                    class="invalid-feedback animated fadeInUp"
                    style={{ display: "block" }}
                  >
                    {errors.pre_booking_percentage}
                  </div>
                )}
              </div>
            </div>
            <div className="custom-checkbox mb-3 col-md-6">
              {/* <label className="text-label d-block">Pre Booking</label> */}
              <div className="form-control d-flex align-items-center justify-content-between gap-2 cursor-pointer" onClick={() => setFieldValue('pre_booking_entry_only', !values.pre_booking_entry_only)} >
                <label
                  className="form-check-label text-label fs-21 m-0"
                  htmlFor="pre_booking_entry_only"
                >
                  Allow Pre Booking Entries Only
                </label>
                <input
                  type="checkbox"
                  className="custom-checkbox-input"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  checked={values.pre_booking_entry_only}
                  value={values.pre_booking_entry_only}
                  name="pre_booking_entry_only"
                  id="pre_booking_entry_only"
                />
              </div>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default AddUpdateUI;
